// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subscriber-account-root[data-v-c3110674]{height:calc(100% - 63px);position:relative;padding:0 0 45px 15px}.log-in-icon[data-v-c3110674]{padding:5px;border-radius:10%;width:30px;height:30px;cursor:pointer}.log-in-icon[data-v-c3110674]:hover{background:#cdcdcd}.subscriber-title[data-v-c3110674]{font-weight:bold;font-size:1.25rem}@media(max-width: 991.98px){.subscriber-title[data-v-c3110674]{font-size:1rem}}", ""]);
// Exports
module.exports = exports;
